function initSecondaryNav() {
  const header = document.getElementById('header');
  if (!header) return;
  header.addEventListener('click', function (e) {
    const trigger = e.target.closest('.has-childs');
    if (!trigger) return;
    e.preventDefault();
    trigger.parentElement.classList.toggle('show');
  });
}

function initSearchComponents() {
  if (!document.querySelector('.search-shell')) return;

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.search-trigger');
    if (!trigger || trigger.tagName !== 'BUTTON') return;

    const searchShell = trigger.closest('.search-shell');
    if (!searchShell) return;

    searchShell.classList.add('is-search-open');
    trigger.setAttribute('aria-expanded', 'true');

    const input = searchShell.querySelector('.search-input');
    if (input) input.focus();
  });
}

function initMobileMenu() {
  var root = document.documentElement;
  var trigger = document.querySelector('.mobile-menu-trigger');
  if (!trigger) return;

  function closeMobileFooterAccordions() {
    var openItems = document.querySelectorAll('.mobile-menu-footer .footer-link-item.is-open');
    openItems.forEach(function (item) {
      item.classList.remove('is-open');
      var title = item.querySelector('.footer-title');
      var submenu = item.querySelector('menu');
      if (title) title.setAttribute('aria-expanded', 'false');
      if (submenu) submenu.hidden = true;
    });
  }

  function setMenuOpen(isOpen) {
    root.classList.toggle('show-mobile-menu', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (!isOpen) {
      closeMobileFooterAccordions();
      return;
    }
    var mobileSearchInput = document.querySelector('.mobile-search-shell .search-input');
    if (mobileSearchInput) mobileSearchInput.focus();
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    var nextState = !root.classList.contains('show-mobile-menu');
    setMenuOpen(nextState);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!root.classList.contains('show-mobile-menu')) return;
    setMenuOpen(false);
  });

  document.addEventListener('click', function (e) {
    if (!root.classList.contains('show-mobile-menu')) return;
    var menuPanelLink = e.target.closest('.mobile-main-menu a, .mobile-menu-footer a');
    if (!menuPanelLink) return;
    setMenuOpen(false);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 820 && root.classList.contains('show-mobile-menu')) {
      setMenuOpen(false);
    }
  });
}

function initFooterAccordions() {
  var containers = document.querySelectorAll('.mobile-menu-footer, .footer-container');
  if (!containers.length) return;

  var mobileFooterMaxWidth = 820;

  function isMobileFooterViewport() {
    return window.innerWidth <= mobileFooterMaxWidth;
  }

  function getFooterLinkItems(container) {
    return Array.from(container.querySelectorAll('.footer-links-container .footer-link-item'));
  }

  function closeItem(item) {
    item.classList.remove('is-open');
    var title = item.querySelector('.footer-title');
    var submenu = item.querySelector('menu');
    if (title) title.setAttribute('aria-expanded', 'false');
    if (submenu) submenu.hidden = true;
  }

  function openItem(item) {
    item.classList.add('is-open');
    var title = item.querySelector('.footer-title');
    var submenu = item.querySelector('menu');
    if (title) title.setAttribute('aria-expanded', 'true');
    if (submenu) submenu.hidden = false;
  }

  function enableDesktopFooterMode(container) {
    getFooterLinkItems(container).forEach(function (item) {
      var title = item.querySelector('.footer-title');
      var submenu = item.querySelector('menu');
      item.classList.add('is-open');
      if (submenu) submenu.hidden = false;
      if (title) {
        title.removeAttribute('role');
        title.removeAttribute('tabindex');
        title.removeAttribute('aria-expanded');
      }
    });
  }

  function enableMobileFooterMode(container) {
    getFooterLinkItems(container).forEach(function (item) {
      var title = item.querySelector('.footer-title');
      var submenu = item.querySelector('menu');
      if (!title || !submenu) return;

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      closeItem(item);
    });
  }

  function syncFooterAccordionMode() {
    containers.forEach(function (container) {
      if (isMobileFooterViewport()) {
        enableMobileFooterMode(container);
      } else {
        enableDesktopFooterMode(container);
      }
    });
  }

  containers.forEach(function (container) {
    container.addEventListener('click', function (e) {
      if (!isMobileFooterViewport()) return;

      var title = e.target.closest('.footer-links-container .footer-title');
      if (!title || !container.contains(title)) return;

      var footerItem = title.closest('.footer-link-item');
      if (!footerItem) return;

      e.preventDefault();
      var footerItems = getFooterLinkItems(container);
      var isOpen = footerItem.classList.contains('is-open');

      footerItems.forEach(function (item) {
        closeItem(item);
      });
      if (!isOpen) openItem(footerItem);
    });

    container.addEventListener('keydown', function (e) {
      if (!isMobileFooterViewport()) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;

      var title = e.target.closest('.footer-links-container .footer-title');
      if (!title || !container.contains(title)) return;
      e.preventDefault();
      title.click();
    });
  });

  syncFooterAccordionMode();
  window.addEventListener('resize', syncFooterAccordionMode);
}

function setHeaderHeightVar() {
  const header = document.getElementById('header');
  if (header) {
    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }
}

function initHeaderHeight() {
  const header = document.getElementById('header');
  if (!header) return;
  setHeaderHeightVar();
  const resizeObserver = new ResizeObserver(setHeaderHeightVar);
  resizeObserver.observe(header);
}

function initBasicEnhancements() {
  initSecondaryNav();
  initSearchComponents();
  initMobileMenu();
  initFooterAccordions();
  initHeaderHeight();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBasicEnhancements, { once: true });
} else {
  initBasicEnhancements();
}
